import React, { useRef } from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import { injectIntl } from "react-intl";
import NoDataToDisplay from "highcharts/modules/no-data-to-display";
// import { postHighChartsMedia } from "../crud/chart.crud";
require("highcharts/modules/annotations")(Highcharts);

function CustomChart(props) {
  const {
    intl,
    chartType,
    chartHeight,
    chartLabel,
    gridLineColor,
    xAxisValue,
    yAxisTitle,
    tooltipLabel,
    showPlotLine,
    data,
    noDataMessage,
    minYScale,
    maxYScale,
    yInterval,
    // storeImageOnServer,
    // title,
    // dataLoaded,
    // reportHash,
    // setDownloadReportDisabled,
    // graphsLoaded
  } = props;

  NoDataToDisplay(Highcharts);
  const chart = useRef();
  const chartOptions = {
    chart: {
      type: chartType,
      zoomType: "x",
      height: chartHeight,
      backgroundColor: null,
      plotBorderColor: "#f01",
      scrollablePlotArea: {
        minWidth: 991
      },
      style: {
        fontFamily: "Roboto",
      },
    },
    title: {
      text: chartLabel,
      align: "left",
      margin: 25,
      style: {
        color: "#1c3545",
        fontSize: "22px",
        fontWeight: 600,
      },
    },
    xAxis: {
      categories: xAxisValue,
      lineColor: gridLineColor,
      labels: {
        style: {
          color: "#203440",
          fontWeight: "700",
        },
      },
    },
    yAxis: {
      plotLines: showPlotLine,
      min: minYScale || null,
      max: maxYScale || null,
      tickInterval: yInterval || null,
      gridLineColor,
      allowDecimals: false,
      title: {
        text: yAxisTitle,
        style: {
          color: "#203440",
          fontWeight: "700",
        },
      },
      labels: {
        style: {
          color: "#203440",
          fontWeight: "700",
        },
      },
    },

    legend: {
      borderWidth: 0,
    },
    tooltip: {
      crosshairs: true,
      shared: true,
      valueSuffix: tooltipLabel,
    },
    credits: {
      text: "propertymonitor.com",
      href: "https://propertymonitor.com",
    },

    series: data,
    lang: {
      noData:
        noDataMessage ||
        intl.formatMessage({ id: "INDEX.CHART.NO_DATA_AVAILABLE" }),
    },
    noData: {
      position: {
        align: "left",
        verticalAlign: "top",
        x: 0,
        y: 0,
      },

      useHTML: true,
    },
    plotOptions: {
      areaspline: {
        fillOpacity: 0.1,
      },
      series: {
        point: {
          events: {
            mouseOver(e) {
              // download()
              // setHoverData(e.target.category);
            },
          },
        },
      },

      spline: {
        lineWidth: 2,
        states: {
          hover: {
            lineWidth: 3,
            halo: {
              size: 0,
            },
          },
        },
        marker: {
          enabled: false,
          symbol: "circle",
          states: {
            hover: {
              lineWidth: 2,
              radius: 4,
            },
          },
        },
      },
    },
  };
  // const exportUrl = "https://export.highcharts.com/";

  // const blob2base64 = (blob) =>
  //   new Promise((resolve, reject) => {
  //     const reader = new FileReader();
  //     reader.onerror = reject;
  //     reader.onload = () => resolve(reader.result);
  //     reader.readAsDataURL(blob);
  //   });

  // const _doMediaUpload = async () => {
  //   const exportChartOptions = { ...chartOptions };
  //   if (title === "pmdpi") {
  //     exportChartOptions.chart.height = 370;
  //     exportChartOptions.chart.width = 700;
  //   }
  //   const body = new FormData();
  //   body.append("infile", JSON.stringify(exportChartOptions));
  //   // body.append('width', 400);

  //   const blob = await fetch(exportUrl, {
  //     body,
  //     method: "post",
  //   }).then((result) => result.blob());
  //   const src = await blob2base64(blob);

  //   const mediaData = {
  //     file: src,
  //     reportHash,
  //     title,
  //   };
  //   try {
  //     const result = await postHighChartsMedia(mediaData);
  //     const { status } = result.data;
  //     if (status === 1) {
  //       graphsLoaded.pmdpi && graphsLoaded.tra && graphsLoaded.act && setDownloadReportDisabled(false);
  //     } else {
  //       // alert("Something went wrong, please refresh the page");
  //       console.log("Something went wrong with upload chart images");
  //     }
  //   } catch (error) {
  //     console.log("Exception :", error);
  //     setDownloadReportDisabled(false);
  //   }
  // };

  // useEffect(() => {
  //   if (storeImageOnServer && dataLoaded) {
  //     // setTimeout(() => {
  //     _doMediaUpload();
  //     // }, 2000);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [dataLoaded]);
  return (
    <div>
      <HighchartsReact
        ref={chart}
        highcharts={Highcharts}
        options={chartOptions}
      />
    </div>
  );
}

export default injectIntl(CustomChart);
